/** The only types the store accepts, verified by magic bytes at the door. */
export const IMAGE_MIMES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
/** MMS's practical ceiling, adopted as ours. */
export const MEDIA_MAX_BYTES = 5 * 1024 * 1024;
